import { useEffect, useState } from "react";
import PermissionGate from "../../layout/PermissionGate";
import axios from "axios";
import { isNumeric } from "validator";

const DriverSharing = ({ id, setAlertConfig, fetchDriverDetails, data }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [sharing, setSharing] = useState(0);
  const [error, setError] = useState("");

  const token = localStorage.getItem("token");

  const updateSharing = async () => {
    const value = Number(sharing);

    if (!Number.isInteger(value) || value < 0 || value > 100) {
      setError("Please enter a valid number (0-100)");
      return;
    }

    setError("");
    setIsLoading(true);

    try {
      const res = await axios.patch(
        `${process.env.REACT_APP_API_ENDPOINT}update-driver-sharing/${id}`,
        { sharing: value },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data.code === 1) {
        setAlertConfig({
          show: true,
          message: res.data.message,
          type: "success",
        });
        fetchDriverDetails();
      } else {
        setAlertConfig({
          show: true,
          message: res.data.message,
          type: "danger",
        });
      }
    } catch (err) {
      console.error(err);
      setAlertConfig({
        show: true,
        message: "Something went wrong",
        type: "danger",
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!data?.sharing) return;
    setSharing(data?.sharing);
  }, [data?.sharing]);

  return (
    <PermissionGate required={`change_driver_custom_sharing`}>
      <div className="card py-10">
        <div className="d-block d-md-flex justify-content-between px-10">
          <div className="fs-2 fw-thin">Custom Sharing ---</div>
          <div className="d-flex mb-0 justify-content-end gap-2 mt-2">
            <div>
              <input
                onChange={(e) => {
                  setSharing(e.target.value);
                  setError("");
                }}
                type="text"
                className="form-control"
                value={sharing ?? 0}
              />
              <small className="text-danger">{error}</small>
            </div>
            <button
              onClick={updateSharing}
              disabled={isLoading}
              className="btn btn-primary text-nowrap d-flex align-items-center justify-content-center"
              style={{ minWidth: "230px" }}
            >
              {isLoading && (
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
              )}
              Change Custom Sharing
            </button>
          </div>
        </div>
      </div>
    </PermissionGate>
  );
};

export default DriverSharing;
